import React from 'react';
import { Title, BoxTitle } from './style';

const Interest = () => (
	<>
		<BoxTitle>
			<Title>
				Se interessou?
				<br />
				<span>Fale com o seu gerente de relacionamento e solicite um orçamento.</span>
			</Title>
		</BoxTitle>
	</>
);

export default Interest;
